import { TFactoryShiftState, TFactoryShiftInfoActionType } from './factory-shift.models';
import { TFactoryShiftActions } from './factory-shift.actions';

export const initialState: TFactoryShiftState = {
  factoryShiftInfo: null,
  factoryHolidayInfo: null,
  shiftCategoryTab: 'WORKING_HOURS',
};

export function factoryShiftReducer(state = initialState, action: TFactoryShiftActions): TFactoryShiftState {
  switch (action.type) {
    case TFactoryShiftInfoActionType.ClearFactoryShiftInfo:
      return {
        ...state,
        factoryShiftInfo: null,
      };
    case TFactoryShiftInfoActionType.SetShiftCategoryTab:
      return {
        ...state,
        shiftCategoryTab: action.currentTab,
      };
    case TFactoryShiftInfoActionType.GetFactoryShiftInfo:
      return {
        ...state,
        factoryShiftInfo: null,
      };
    case TFactoryShiftInfoActionType.GetFactoryShiftInfoSuccess:
      return {
        ...state,
        factoryShiftInfo: action.factoryShiftRes,
      };
    case TFactoryShiftInfoActionType.GetFactoryHolidaysInfo:
      return {
        ...state,
        factoryHolidayInfo: null,
      };
    case TFactoryShiftInfoActionType.GetFactoryHolidaysInfoSuccess:
      return {
        ...state,
        factoryHolidayInfo: action.factoryHolidayRes,
      };
    default:
      return state;
  }
}
